// @flow
import React from 'react';
import gql from 'graphql-tag';
import withQueryService from 'components/hoc/withQueryService';
import { pathOr } from 'rambda';
import { Col, Row } from 'components/Layout';
import View from 'components/View';
import { Helmet } from 'react-helmet';
import { ThemeProvider } from 'react-fela';
import { withCookies } from 'react-cookie';
import LanguageSwitcher from 'WebModule/i18n/LanguageSwitcher';
import Sidebar from '../MainPage/Sidebar';
import { coloredTheme } from '../themes/default';
import { getAllowLanguageSwitch } from '../../utils/i18n';

const query = gql`
  query {
    companies(first: 1) {
      edges {
        node {
          color
        }
      }
    }
  }
`;

const styles = {
  pageWrapper: {
    height: '100%',
    position: 'relative'
  },
  languageSwitcherStyles: {
    position: 'absolute',
    top: '10px',
    right: '10px',

    '& select': {
      color: 'silver'
    },

    '& svg': {
      color: 'silver'
    }
  }
};

const App = ({ QueryService, children, cookies }) => (
  <View style={styles.pageWrapper}>
    <QueryService variables={{}} query={query}>
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) return null;

        const companiesSet = pathOr(null, 'companies.edges', data);
        const company = companiesSet && companiesSet[0] ? companiesSet[0].node : null;
        const color = company && company.color;
        const allowLanguageSwitcher = getAllowLanguageSwitch(cookies);

        return (
          <ThemeProvider overwrite theme={coloredTheme(color)}>
            <Row>
              <Helmet titleTemplate="%s | LoyalMan" defaultTitle="LoyalMan" />

              <Col size="menu-expanded">
                <Sidebar />
              </Col>

              {allowLanguageSwitcher ? (
                <View style={styles.languageSwitcherStyles}>
                  <LanguageSwitcher changeDB />
                </View>
              ) : null}

              {children}
            </Row>
          </ThemeProvider>
        );
      }}
    </QueryService>
  </View>
);

export default withCookies(withQueryService(App));
